import React from "react";
import styled from "styled-components";
import NavLink from "react-router-dom/NavLink";

import { get, mixin, responsiveImg } from "package-common-react/lib/style/util";
import NativeLegalButton from "package-common-react/lib/components/LegalButton";

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Header = styled.header`
  background: ${get('color.blue')};
  color: #FFF;
  padding: 25px;
`;

export const Headline = styled.h1`
  ${mixin('font.bold', 36, 1)};
  color: #FFF;
  text-align: center;
  width: 100%;
  
  small {
    ${mixin('font.bold', 26)};
    display: block;
  }
`;

export const HomeLink = styled(NavLink)`
  background: ${get('color.blue')};
  border: 8px solid #FFF;
  border-radius: 16px;
  display: block;
  margin: 10px 0;
  padding: 15px 30px;
  width: 196px;
`;

export const ImageLogo = styled.img`
  ${responsiveImg()};
`;

export const Main = styled.main`
  background: ${get('color.yellow')};
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-around;
  padding: 25px;
`;

export const Footer = styled.footer`
  background: ${get('color.yellow')};
  padding: 25px;
  padding-top: 0;
  
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
`;

export const LegalButton = NativeLegalButton.extend`
`;



// WEBPACK FOOTER //
// ./src/pages/PreHome/style.js